import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faCodeBranch } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
    return (
        <footer>
            <Container className="text-center my-3">
                <p>Designed & Built by <a target="_blank" rel="noreferrer" href="https://github.com/solaimanshadin">Solaiman Shadin</a></p>
                <div>
                    <FontAwesomeIcon icon={faStar}/> <span>Star</span> <span className="mx-3">&</span> 
                    <FontAwesomeIcon icon={faCodeBranch}/> <span className="mr-3">Froks</span>
                    <a target="_blank" className="text-white" rel="noreferrer" href="https://github.com/solaimanshadin"><span className="badge bg-success">By Me</span></a>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;